import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-duplicated-order-numbers',
  templateUrl: './duplicated-order-numbers.component.html'
})
export class DuplicatedOrderNumbersComponent {

  @Output() public finish = new EventEmitter<boolean>();

  private continueSave: boolean = false;

  constructor(private bsModalRef: BsModalRef) {
  }

  public cancel(): void {
    this.close();
  }

  public save(): void {
    this.continueSave = true;
    this.close();
  }

  private close(): void {
    this.finish.emit(this.continueSave);
    this.bsModalRef.hide();
  }
}
